import * as ACTIONS from '../constants/patientReplaceForm';

const initialState = {
  loading: false,
  error: false,
  success: {
    Code: '',
    CardID: '',
  },
  step: 0,
  patientInformation: {
    mobilePhoneNumber: '',
    dob: '',
  },
};

function patientReplaceForm (state = initialState, action) {
  switch (action.type) {
    case ACTIONS.PATIENT_REPLACE.CHANGE_STEP:
    case ACTIONS.SUBMIT_PATIENT_REPLACE_FORM.INIT:
    case ACTIONS.SUBMIT_PATIENT_REPLACE_FORM.ERROR:
    case ACTIONS.SUBMIT_PATIENT_REPLACE_FORM.SUCCESS:
      return {
        ...state,
        ...action.payload,
      };
    case ACTIONS.PATIENT_REPLACE.VERIFY_PATIENT_INFO:
      return {
        ...state,
        patientInformation: {
          ...state.patientInformation,
          ...action.payload,
        },
      };
    case ACTIONS.PATIENT_REPLACE.CLEAR:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
}

export default patientReplaceForm;
